export default "__VITE_ASSET__BD4zx1Dm__"